export function removeErrorMessage(input) {
    jQuery(input).removeClass('error');
    let errorMessage = jQuery(input).closest('.input-wrapper').find('.error-message');
    if (errorMessage) {
        errorMessage.remove();
    }
}

export function addErrorMessage(input, message) {
    message = message || 'This field is required';
    jQuery(input).addClass('error');
    jQuery(input).after('<span class="error-message">'+message+'</span>');
}

export function validateFormSubmit(form) {
    let formElement = jQuery(form);
    let valid = true;

    // // Select all required inputs
    let requiredInputs = Array.from(formElement.find('input[required]'));
    
    let i = 0;
    requiredInputs.forEach(function(input) {

        if (input.value.length === 0) {
            removeErrorMessage(input);
            addErrorMessage(input, 'This field is required');
            if (i === 0) {
                input.focus();
                i++;
            }
            valid = false;
        } else {
            removeErrorMessage(input);
        }

        // Validate email input
        if (input.type === 'email' && input.value.length > 0) {
            let emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
            if (!input.value.match(emailPattern)) {
                removeErrorMessage(input);
                addErrorMessage(input, 'Please enter a valid email address');
                valid = false;
            } else {
                removeErrorMessage(input);
            }
        }

        // Validate phone input
        if (input.type === 'tel' && input.value.length > 0) {
            let phonePattern = /^(?=(?:[+ -]*[0-9][+ -]*){9,16}$)(?:\+)?(?:[0-9]+[ -]?)+[0-9]$/mg;
            if (!input.value.match(phonePattern)) {
                removeErrorMessage(input);
                addErrorMessage(input, 'Please enter a valid phone number');
                valid = false;
            } else {
                removeErrorMessage(input);
            }
        }
    });

    return valid;
}

export function validateInput(ele) { 
    const self = ele.length > 0 ? ele[0] : this

    if (self.value.length === 0) { 
        removeErrorMessage(self);
        addErrorMessage(self, 'This field is required');
    } else {
        removeErrorMessage(self);
    }
}

// Validate email input
export function validateEmailInput() { 
    let email = this.value;
    let emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    if( !email.match(emailPattern) && email.length > 0) {
        removeErrorMessage(this); 
        addErrorMessage(this, 'Please enter a valid email address');
    } else {
        removeErrorMessage(this);
    }
}